export const servicesTranslations = {
  en: {
    "seo.services.title": "Services & Advisory Programmes | Peter Dingle",
    "seo.services.description":
      "Find the right support: Stage 1 Investor Readiness, Stage 2 Investor Engagement, embedded advisory, the Founder Laws book, and founder courses.",

    "services.groups.advisory.title": "Monthly Advisory Programmes",
    "services.groups.advisory.blurb":
      "Structured, ongoing advisory for founders raising capital. Start at Stage 1 if you are getting investor-ready; move to Stage 2 when you are actively engaging investors.",
    "services.groups.book.title": "The Founder Laws Book",
    "services.groups.book.blurb":
      "50 hard truths for startup survival — the fastest, cheapest way to start.",
    "services.groups.courses.title": "Courses & Workshops",
    "services.groups.courses.blurb":
      "Self-contained sessions on fundraising, go-to-market, valuation and scaling.",
    "services.groups.speaking.title": "Speaking & Keynotes",
    "services.groups.speaking.blurb":
      "Executive and keynote engagements by arrangement — for conferences, boards and leadership offsites.",

    "services.header.title": "Find the right service for where you are",
    "services.header.subtitle":
      "Most founders start with Stage 1 Investor Readiness and progress to Stage 2 when they are in market with investors. Not sure? Book a 20-minute founder call and we will place you correctly.",
    "services.header.cta": "Book a 20-Minute Founder Call",

    "services.compare.stage1.step": "Stage 1",
    "services.compare.stage1.title": "Investor Readiness",
    "services.compare.stage1.text":
      "You need the story, numbers and materials to stand up to investor scrutiny.",
    "services.compare.stage2.step": "Stage 2",
    "services.compare.stage2.title": "Investor Engagement",
    "services.compare.stage2.text":
      "You are ready and now running a process — pipeline, meetings, follow-through.",
    "services.compare.ongoing.step": "Ongoing",
    "services.compare.ongoing.title": "Embedded Advisor",
    "services.compare.ongoing.text":
      "Founder advisory for moments where decisions compound — capital, pilots, hiring.",
    "services.compare.viewProgramme": "View programme",

    "services.other.title": "More Products & Resources",
    "services.other.subtitle": "Additional offers and resources that don't fit the categories above.",
  },
  zh: {
    "seo.services.title": "服务与咨询项目 | Peter Dingle",
    "seo.services.description":
      "找到适合你的支持方式：第一阶段“投资人准备度”、第二阶段“投资人对接”、常驻顾问服务、《创始人法则》一书，以及创始人课程。",

    "services.groups.advisory.title": "月度咨询项目",
    "services.groups.advisory.blurb":
      "为正在融资的创始人提供系统、持续的咨询支持。若你正在准备投资人材料，从第一阶段开始；若你已在积极对接投资人，则进入第二阶段。",
    "services.groups.book.title": "《创始人法则》一书",
    "services.groups.book.blurb": "50条创业生存的硬道理——最快、最省钱的起点。",
    "services.groups.courses.title": "课程与工作坊",
    "services.groups.courses.blurb": "围绕融资、市场进入、估值与规模化的独立课程。",
    "services.groups.speaking.title": "演讲与主题分享",
    "services.groups.speaking.blurb":
      "按约定安排的高管及主题演讲——适用于行业会议、董事会及领导层务虚会。",

    "services.header.title": "找到符合你当前阶段的服务",
    "services.header.subtitle":
      "大多数创始人从第一阶段“投资人准备度”开始，等到正式与投资人接触后再进入第二阶段。不确定该从哪里开始？预约一次20分钟的创始人通话，我们会帮你判断合适的起点。",
    "services.header.cta": "预约20分钟创始人通话",

    "services.compare.stage1.step": "第一阶段",
    "services.compare.stage1.title": "投资人准备度",
    "services.compare.stage1.text": "你需要打磨故事、数据和材料，使其经得起投资人的审视。",
    "services.compare.stage2.step": "第二阶段",
    "services.compare.stage2.title": "投资人对接",
    "services.compare.stage2.text":
      "你已准备就绪，正在推进具体流程——包括意向管道、会面安排与后续跟进。",
    "services.compare.ongoing.step": "长期陪伴",
    "services.compare.ongoing.title": "常驻顾问",
    "services.compare.ongoing.text":
      "在关键决策积累影响的时刻提供创始人咨询——融资、试点合作、招聘。",
    "services.compare.viewProgramme": "查看项目详情",

    "services.other.title": "更多产品与资源",
    "services.other.subtitle": "其他不属于以上类别的补充产品与资源。",
  },
} as const;
